import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_ReferralAndIntake = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_ReferralAndIntake' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'> <center> <h3> <b> REFERRAL & INTAKE FORM </b> </h3> </center>
                </p>
                <p className='w-750'> <center> <h5> <b> REFERRAL </b> </h5> </center>
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Referral Date: </span> </td>
                        <td className='w-500'> <span className='eleHeader'> Name of Referral Source (List agency/company name): </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='date' id='txtReferralDate' name='txtReferralDate' className='add-only' /> </td>
                        <td className='w-500'> <input type='text' id='txtReferralSource' name='txtReferralSource' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Name of Person Making Referral: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Phone Number for Person Making Referral: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Fax Number for Person Making Referral: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtNameOfPerson' name='txtNameOfPerson' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtNumberForPerson' name='txtNumberForPerson' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtFaxNumber' name='txtFaxNumber' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <center> <h3> <b> CLIENT INFORMATION </b> </h3> </center>
                </p>

                <table>
                    <tr>
                        <td className='w-300'> <span className='eleHeader'> Client Name: </span> </td>
                        <td className='w-200'> <span className='eleHeader'> DOB: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Gender: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtClientName' name='txtClientName' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtDob' name='txtDob' className='add-only' /> </td>
                        <td className='w-250'>
                            <input type='radio' id='rbGender_Male' name='rbGender' className='add-only' value='Male' /> Male &nbsp;
                            <input type='radio' id='rbGender_Female' name='rbGender' className='add-only' value='Female' /> Female </td>
                    </tr>

                    <tr>
                        <td className='w-200'> <span className='eleHeader'> Medicaid #: </span> </td>
                        <td className='w-200'> <span className='eleHeader'> Language Preference: </span> </td>
                        <td className='w-350'> <span className='eleHeader'> Parent/Guardian Name (if client is under 18): </span> </td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type='text' id='txtMedicaid' name='txtMedicaid' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtLanguage' name='txtLanguage' className='add-only' /> </td>
                        <td className='w-350'> <input type='text' id='txtGuardianName' name='txtGuardianName' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-350'> <span className='eleHeader'> Residential Address: </span> </td>
                        <td className='w-150'> <span className='eleHeader'> City: </span> </td>
                        <td className='w-100'> <span className='eleHeader'> ZIP: </span> </td>
                        <td className='w-150'> <span className='eleHeader'> County: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <input type='text' id='txtResidentialAddress' name='txtResidentialAddress' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCity' name='txtCity' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtZip' name='txtZip' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCounty' name='txtCounty' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-150'> <span className='eleHeader'> Phone Numbers: </span> </td>
                        <td className='w-150'> <span className='eleHeader'> Home: </span> </td>
                        <td className='w-150'> <span className='eleHeader'> Work: </span> </td>
                        <td className='w-150'> <span className='eleHeader'> Cell: </span> </td>
                        <td className='w-150'> <span className='eleHeader'> Other: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='text' id='txtPhoneNumbers' name='txtPhoneNumbers' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtHome' name='txtHome' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtWork' name='txtWork' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCell' name='txtCell' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtOther_1' name='txtOther_1' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Health Condition/Health Risk (Child) or High-Risk Condition (Pregnant Woman) / Case Management Needs Per Referral
                        Source: </span>
                    <textarea id='txtHealthRisk' name='txtHealthRisk' className='add-only'> </textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Referral section completed by: </span>
                    <textarea id='txtReferralSection' name='txtReferralSection' className='add-only'> </textarea>
                </p>

                <p className='w-750'> <center> <h3> <b> INTAKE </b> </h3> </center>
                </p>
                <p className='w-750'> <center> <b> (completed by case manager with client/parent/guardian) </b> </center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Date of Intake: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Information provided by: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtIntake' name='txtIntake' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtInformationProvided' name='txtInformationProvided' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbInformation_1' name='cbInformation_1' className='add-only' value='Information same as provided' /> Information same as provided by referral source; <br />
                            <input type='checkbox' id='cbGuardian_1' name='cbGuardian_1' className='add-only' value='Additional information provided' /> Additional information provided by client/parent/guardian; Include expected date of delivery if pregnant:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtMedicalHistory' name='txtMedicalHistory' className='add-only'> </textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'> Outcome of Referral </span>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbEligibleNeeds' name='cbEligibleNeeds' className='add-only' value='Eligible Needs' /> Eligible needs. Submit initial prior authorization request for case management services. <br />
                            <input type='checkbox' id='cbRoutineMedical' name='cbRoutineMedical' className='add-only' value='Routine Medical' /> Routine medical and dental needs. Refer to Texas Health Steps Hotline or MCO. <br />
                            <input type='checkbox' id='cbMedicalTransportation' name='cbMedicalTransportation' className='add-only' value='Medical Transportation ' /> Routine medical transportation needs. Refer to Medical Transportation Program. <br />
                            <input type='checkbox' id='cbBasicNeedsOnly' name='cbBasicNeedsOnly' className='add-only' value='Basic needs only' /> Basic needs only. Refer to 2-1-1 or other community resource. <br />
                            <input type='checkbox' id='cbNeedsIdentified' name='cbNeedsIdentified' className='add-only' value='Needs Identified' /> Not interested in case management services and/or no needs identified. <br />
                            <input type='checkbox' id='cbOther_2' name='cbOther_2' className='add-only' value='Other' /> Other:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOther_3' name='txtOther_3' className='add-only' /> </td>
                        <td className='w-375'>
                        </td>
                    </tr>
                </table>

                <p className='w-750'> <b> Attempts to Contact Client/Parent/Guardian </b>
                </p>

                <table>
                    <tr>
                        <td className='w-200'> <span className='eleHeader'> Date of Attempts: </span> </td>
                        <td className='w-550'> <span className='eleHeader'> Action: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-20'> 1. </td>
                        <td className='w-180'> <input type='date' id='txtAttempts_1' name='txtAttempts_1' className='add-only' /> </td>
                        <td className='w-550'> <input type='text' id='txtAction_1' name='txtAction_1' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-20'> 2. </td>
                        <td className='w-180'> <input type='date' id='txtAttempts_2' name='txtAttempts_2' className='add-only' /> </td>
                        <td className='w-550'> <input type='text' id='txtAction_2' name='txtAction_2' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-20'> 3. </td>
                        <td className='w-180'> <input type='date' id='txtAttempts_3' name='txtAttempts_3' className='add-only' /> </td>
                        <td className='w-550'> <input type='text' id='txtAction_3' name='txtAction_3' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Intake completed by: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtIntakeCompleted' name='txtIntakeCompleted' className='add-only' /> </td>
                    </tr>
                </table>

            </div>
        </form>

    )
}











